module.exports = __webpack_public_path__ + "static/media/RP-33.6bbe316a.pdf";